import { useEffect, useState } from "react";
import Menu from "../../components/Menu";
import Back from '../../assets/img/de-volta.svg'

import MedicinesList from "../../components/MedicinesList";
import More from '../../assets/img/mais.svg'
import PDF from '../../assets/img/PDF.svg';
import MedicinePills from '../../assets/img/pilulas-black.svg'
import { Link } from 'react-router-dom'
import { Form } from "react-bootstrap";
import api from "../../services/api";

import { pdf } from "@react-pdf/renderer";
import { PDFReport } from "../../components/PDFReport";
import Swal from "sweetalert2";

export default function Medicines() {
  const [search, setSearch] = useState('')
  const [isMissing, setIsMissing] = useState(false);
  const [totalMissingMedicines, setTotalMissingMedicines] = useState(0);
  const [lastMissingMedicinesPage, setLastMissingMedicinesPage] = useState(null);
  const [missingMedicines, setMissingMedicines] = useState([]);

  const handleMissingMedicines = async () => {
    setIsMissing(!isMissing);
  };

  useEffect(() => {
    const getMissingMedicinesQuantity = async () => {
      await api.get('/api/pharmacydrugs/without-list').then((response) => {
        setTotalMissingMedicines(response.data.total);

        //guarda a ultima pagina para o relatorio
        setLastMissingMedicinesPage(response.data.last_page);

        //guarda os medicamentos da primeira página
        setMissingMedicines(response.data.data);
      }).catch((error) => {
        console.error(error)
      })
    }

    getMissingMedicinesQuantity();
  }, []);

  const getMissingMedicines = async () => {
    let allMedicines = [...missingMedicines];
    
    if(lastMissingMedicinesPage >= 2){
      let page = 2;
      while(page <= lastMissingMedicinesPage){
        try {
          const response = await api.get(`/api/pharmacydrugs/without-list?page=${page}`);
          allMedicines = [...allMedicines, ...response.data.data];
          page += 1;
        } catch(error) {
          console.error(error);
        }
      }
    }
    
    return allMedicines;
  }
  

  const handleDownloadPdf = async () => {
    const result = await Swal.fire({
      title: 'Deseja baixar relatório de medicamentos em falta?',
      text: "Confirme para iniciar o download.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, baixar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      // Mostra alerta de loading
      Swal.fire({
        title: 'Gerando relatório...',
        text: 'Aguarde um momento.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const allMedicines = await getMissingMedicines();

      const date = new Date();
      const timestamp = date.getDate() + '-' + date.getMonth() + '-' + date.getFullYear() + '_' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
      const blob = await pdf(<PDFReport medicines={allMedicines} />).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Relatorio-Faltas-Farmacia-${timestamp}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      // Fecha o alerta de loading
      Swal.close();
    }
  };

  const screenTela =
    <div className="ms-4 mt-3">
      <div className="row row-container">

        <h1 className="col-6 col-sm-6 col-lg-6 name-screen my-4"> <img style={{ width: '40px' }} alt="svg" src={MedicinePills} /> <span className="name-screen-title" >Medicamentos</span> </h1>

        <div className="col-6 col-sm-6 col-lg-6 name-search my-4 align-items-center">
          <input value={search} onChange={(value) => {
            setSearch(value.target.value)
          }} type="text" placeholder="Pesquisar Medicamentos" className="form-control input-pesquisa" />

          <div className="d-flex align-items-baseline position-relative" style={{ right: '50px' }}>

            <Form.Check
              type="switch"
              id="missing-medicines"
              label="Medicamentos em falta"
              className="mt-3 mr-3"
              checked={isMissing}
              onChange={handleMissingMedicines}
            />

            {(totalMissingMedicines > 0) && (<span className="ms-3 rounded-circle p-1 text-center" style={{ backgroundColor: 'rgb(251, 56, 56)', color: 'white', fontSize: '14px', width: '30px', height: '30px' }}>{totalMissingMedicines}</span>)}

          </div>
        </div>

        <MedicinesList search={search} isMissing={isMissing} />

      </div>

      {
        isMissing && (
        <div className="button-pdf"  onClick={handleDownloadPdf} style={{ cursor: 'pointer' }} title="Baixar relatório">
          <img alt="Baixar Relatório" src={PDF} style={{ fill: 'red' }} />
        </div>
        )
      }

      <Link to="/dashboard" title="Voltar">
        <div className="button-back-list">
          <img alt="mais" src={Back} />
        </div>
      </Link>
      <Link to="add" title="Novo medicamento">
        <div className="button-add">
          <img alt="mais" src={More} />
        </div>
      </Link>
    </div>

  return (
    <Menu screen={screenTela} />
  )
}
